import i18n from './index'

// API labels vary in spelling and separators across the log endpoints.
// Reuse the same catalog entries as the corresponding filter options.
const systemLabelKeys = {
  canceled: 'system.cancelled',
  screenout: 'system.screen_out',
  payout: 'logs.payout',
  bonus: 'apps.bonus',
  reconciliation: 'apps.reconciliation',
  custom: 'logs.custom',
  offer_completed: 'logs.offerCompleted',
  pre_qualification_reward: 'logs.preQualificationReward',
  pending_reconciled: 'logs.pendingReconciled',
  unknown_type: 'logs.unknownType',
}

// Call only for known system labels, never publisher-entered names or API errors.
export function systemLabel(value) {
  if (typeof value !== 'string') return value
  const normalizedValue = value.trim().toLowerCase().replace(/[\s-]+/g, '_')
  const key = systemLabelKeys[normalizedValue] || `system.${normalizedValue}`
  return i18n.te(key, 'en') ? i18n.t(key) : value
}

export function permissionLabel(permission, fallback) {
  const key = `permissions.${permission}`
  return i18n.te(key, 'en') ? i18n.t(key) : fallback || permission.replace(/_/g, ' ')
}

export function chartSeries(series) {
  return (series || []).map(item => ({ ...item, name: systemLabel(item.name) }))
}
